<template>
    <div>
        <!-- Field Selection -->
        <div v-if="!fieldSelected && !showRulesList">
            <label class="mr-4" for="fieldSelection">Choose Field</label>
            <el-select
                id="fieldSelection"
                v-model="fieldSelected"
                collapse-tags
                @change="handleFieldChange"
            >
                <el-option
                    v-for="field in getAddableFields"
                    :value="field"
                    :label="field.name"
                />
            </el-select>
            <div class="d-flex justify-content-end">
                <el-button @click="showRulesList = true" class="btn btn-secondary">
                    Back
                </el-button>
            </div>
        </div>
        <div v-else-if="(fieldSelected && !showRulesList) || editingRule">
            <el-form label-width="300px">
                <el-form-item label="Name">
                    <el-input v-model="rule.name" disabled/>
                </el-form-item>
                <el-form-item label="Title">
                    <el-input v-model="rule.title" disabled/>
                </el-form-item>
                <el-form-item
                    label="Value">
                        <el-input
                            v-model="rule.value"
                            type="textarea"
                            rows="5"/>
                </el-form-item>
            </el-form>
            <div class="d-flex justify-content-end">
                <el-button @click="backFromForm" class="btn btn-secondary">
                    Back
                </el-button>
                <el-button @click="addOrUpdateRule" class="btn btn-primary">
                    {{ editingRule ? 'Update Rule' : 'Add Rule' }}
                </el-button>
            </div>
        </div>

        <div v-else>
            <div>
                <label class="mr-4" for="validation-message">Rule Name</label>
                <el-input id="validation-message" v-model="name"/>
            </div>
            <div class="mt-3">
                <label class="mr-4" for="validation-message">Enter Validation Error Message</label>
                <el-input id="validation-message" v-model="message"/>
            </div>
            <p class="mt-4" v-if="rules.length"><strong>Rules:</strong></p>
            <div class="validations-container">

                <div class="validations-container-inner" v-for="(r,i) in rules">

                    <div v-if="i!=0" style="width: 200px; display: flex; justify-content: center;">
                        <div class="and-or-container">
                            <button  class="and-btn active-btn">AND</button>
                        </div>

                    </div>

                    <div class="validation-field-container">
                        <div class="validation-field">
                            <span>{{ r.name }}</span>
                            <span><strong>Value: </strong>{{ r.value }}</span>
                        </div>
                        <div class="edit-or-delete-container">
                            <button @click="editRule(r)" class="nbtn nbtn-warnign mr-2">Edit</button>
                            <button @click="removeRule(r)" class="nbtn nbtn-danger">Delete</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-4 d-flex justify-content-between">
                <button @click="showAddNewField" class="btn">Add New Field</button>
                <div>
                    <button v-if="mode == 'edit'" @click="$emit('close')" class="btn btn-primary mr-2">Cancel</button>
                    <button @click="$emit('data', rules, message, name)" class="btn btn-primary">{{ mode == 'edit' ? 'Update' : 'Add As' }} Validation</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default{
    props:{
        allFields: {
            type: Array,
            required: true
        },
        data:{
            type: Object,
            default: null
        },
        mode:{
            type: String,
            default: "create"
        }
    },
    computed:{
        getAddableFields(){
            const addedFieldIds = this.rules.map(f => f.fid)
            return this.allFields.filter(field=> !addedFieldIds.includes(field._id))
        },
    },
    data(){
        return {
            fieldSelected: null,
            rules: [],
            showRulesList: false,
            editingRule: false,
            rule:{
                name: "",
                title: "",
                value: "",
                fid: ''
            },
            message: '',
            name: '',
        }
    },
    methods:{
        handleFieldChange(field){
            this.fieldSelected = true
            this.rule = {
                name: field.name,
                title: field.title,
                value: "",
                fid: field._id
            }
        },
        addOrUpdateRule(){
            if(this.editingRule){
                this.rules.forEach(r =>{
                    if(r.fid == this.rule.fid){
                        r.value = this.rule.value
                    }
                })
                this.editingRule = false
                this.showRulesList = true
            }else{
                this.rules.push(this.rule)
                this.showRulesList = true
            }
        },
        showAddNewField(){
            // clear old values and show the field selection
            this.fieldSelected = null
            this.rule = {
                name: "",
                title: "",
                value: "",
                fid: ''
            }

            this.showRulesList = false
        },
        editRule(r){
            this.editingRule = true
            this.rule = {
                ...r
            }

        },
        removeRule(r){
            this.rules = this.rules.filter(f => f.fid != r.fid)
        },
        backFromForm(){
            if(this.editingRule){
                this.showRulesList = true
                this.editingRule = false
            }else{
                this.showRulesList = false
                this.fieldSelected = null
            }
        }
    },
    mounted(){
        if(this.mode == 'edit'){
            this.rules = [...this.data.rules]
            this.message = this.data.message
            this.name = this.data.name
            this.showRulesList = true
        }
    }
}
</script>

<style scoped>
.validations-container{
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin-top: 10px;
}

.validations-container-inner{
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
}

.validation-field-container{
    display: flex;
}

.validation-field{
    text-align: center;
    height: 150px;
    width: 200px;
    margin: 0;
    border: 1px solid #ccc;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    position: relative;
    gap:5px;

}

.edit-or-delete-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: white;
    padding: 20px;
}

.nbtn{
    background: none;
    border: none;
}

.nbtn:hover{
    text-decoration: underline;
}
.nbtn.nbtn-danger:hover{
    color: red;
}
.nbtn.nbtn-warnign:hover{
    color: rgb(0, 136, 255);
}

.validation-field:hover .edit-or-delete-container,
.validation-field p:hover .edit-or-delete-container{
    display: flex;
}

.btn-circle{
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
}


.and-or-container{
    border: 1px solid #9f9f9f;
    border-radius: 3px;
    width: max-content;
}

.and-btn,
.or-btn{
    background: #fff;
    border: none;
    display: inline-block;
    width: 50px;
    padding: 5px;
}

.and-btn:hover, 
.or-btn:hover{
    background: #dddddd;
}


.and-btn.active-btn{
    background: #388e3c;
    color: white;
}
.or-btn.active-btn{
    background: #388e3c;
    color: white;
}
</style>